// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d3-a";
export var fulfillmentFormRail = "_d3-9";
export var headerTitleRow = "_d3-c";
export var orderDetailsWrapper = "_d3-7";
export var orderLinkTrigger = "_d3-2";
export var paymentInformationGrid = "_d3-h";
export var paymentSummaryColumn = "_d3-i";
export var shipmentContainer = "_d3-b";
export var shipmentDetailsMainPane = "_d3-8";
export var shipmentNavigationCard = "_d3-5";
export var shipmentNavigationRail = "_d3-3";
export var shipmentNavigationRailHeader = "_d3-4";
export var shipmentSummaryFact = "_d3-e";
export var shipmentSummaryGrid = "_d3-d";
export var shipmentSummaryMetadataRow = "_d3-f";
export var shipmentSummaryTags = "_d3-g";
export var shipmentWorkspace = "_d3-0";
export var shipmentWorkspaceContent = "_d3-6";
export var shipmentWorkspaceHeader = "_d3-1";